import React, { useEffect } from "react";
import { IOrderResponse } from "../../../../../../../../../Interfaces/responseTypes";
import OrderCard from "../Cards/myOrderCard";
import styles from "./myOrderList.module.scss";
import { CircularProgress } from "@mui/material";
import NoData from "../../../../../../../../../Components/NoData/noData";

interface IProps {
  orders: IOrderResponse[];
  onSelect: (order: IOrderResponse) => void;
  sentinelRef: (node: HTMLDivElement | null) => void;
  isFetching: boolean;
}

const OrderList: React.FC<IProps> = ({ orders, onSelect, sentinelRef, isFetching }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);


  if (isFetching && orders.length === 0) {
    return (
      <div className={styles.loadingWrapper}>
        <CircularProgress sx={{ color: "#b00020" }} size="35px" />
      </div>
    );
  }

  if (!isFetching && orders.length === 0) {
    return (
      <div className={styles.noOrderBox}>
        <NoData />
      </div>
    );
  }

  return (
    <div className={styles.orderList}>
      {orders.map((order) => (
        <OrderCard key={order.id} order={order} onSelect={onSelect} />
      ))}
      {isFetching &&
        <div className={styles.loadingWrapper}>
          <CircularProgress sx={{ color: "#b00020" }} size="25px" />
        </div>
      }
      <div ref={sentinelRef} style={{ height: 1 }} />
    </div>
  );
};

export default OrderList;